import { Button, GridLegacy as Grid, MenuItem, Select, Stack, TextField } from '@mui/material'
import { useRef } from "react";
import SignatureCanvas from 'react-signature-canvas'
import styled from "@emotion/styled";
import { Label } from "@mui/icons-material";

const DocumentSign = styled.div`
  border: 1px solid black;
  width:200px;
  heigth:100px;
  margin-left:auto;
  margin-right:auto;
`;

export const FormFirma = ({
    datos_conductor={},
    onChangeData
})=>{

    const canvasRef = useRef(null);

    const borrarFirma = ()=>{
        canvasRef.current.clear();
        onChangeData("firma","");
    }
    const updateFirma = (evt)=>{
       const firma =  canvasRef.current.toDataURL();
       onChangeData("firma",firma);
    }
  
    return (
        <Grid container spacing={1} >
        <Grid  item sm={12} sx={12} md={12}  >
            <TextField 
            onChange={e=>onChangeData(e.target.name,e.target.value)}
         
            name="nombre_conductor" 
            fullWidth 
            size="small" 
            label='Nombre del conductor' />
        </Grid>
        
        <Grid item sm={12} sx={12} md={12}  >
            <TextField 
              onChange={e=>onChangeData(e.target.name,e.target.value)}
             
            name="numero_documento" 
            fullWidth 
            size="small"  
            label='Numero de documento' />
        </Grid>
        <Grid item sm={12} sx={12} md={12}  >
            <DocumentSign>
                <Label>Firma del conductor</Label>
                <SignatureCanvas 
                    penColor={'black'}
                    ref={canvasRef}
                    onEnd={updateFirma}
                    canvasProps={{width: 200, height: 100, className: 'sigCanvas'}} />
                
                <Stack direction={"row"} justifyContent={"end"} marginTop={'10px'} >
                <Button  onClick={borrarFirma} sx={{marginRight:'10px'}} variant="contained" color="secondary" size="small" >Borrar</Button>
                 
                </Stack>
            </DocumentSign>

        </Grid>
    </Grid>
    )

}